import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/element/constrainable/styles.scss';export default {
  "constrainable": "_constrainable_1eyh4_1",
  "origin": "_origin_1eyh4_14",
  "target": "_target_1eyh4_18",
  "hovered": "_hovered_1eyh4_22"
};